/* Quiénes somos — comportamiento de las secciones .qs (aparición, titular animado, fachada, galería) */
(function () {
  if (window.__qsLoaded) return; window.__qsLoaded = true;
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function reveal(root) {
    var els = root.querySelectorAll('.reveal:not([data-qs])');
    for (var i = 0; i < els.length; i++) els[i].setAttribute('data-qs', '1');
    if (!('IntersectionObserver' in window) || reduce) { for (var j = 0; j < els.length; j++) els[j].classList.add('in'); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); } });
    }, { threshold: 0.12, rootMargin: '0px 0px -6% 0px' });
    for (var k = 0; k < els.length; k++) io.observe(els[k]);
  }

  function mask(root) {
    var m = root.querySelector('.mask:not([data-qs])'); if (!m) return;
    m.setAttribute('data-qs', '1');
    var kk = 0, nodes = Array.prototype.slice.call(m.childNodes); m.textContent = '';
    var box = document.createElement('span'); box.setAttribute('aria-hidden', 'true');
    nodes.forEach(function (n) {
      var isSpan = n.nodeType === 1;
      n.textContent.split(/(\s+)/).forEach(function (w) {
        if (!w) return;
        if (/^\s+$/.test(w)) { box.appendChild(document.createTextNode(' ')); return; }
        var wd = document.createElement('span'); wd.className = 'wd' + (isSpan ? ' hl' : '');
        w.split('').forEach(function (c) { var ch = document.createElement('span'); ch.className = 'ch'; ch.textContent = c; ch.style.setProperty('--k', kk++); wd.appendChild(ch); });
        box.appendChild(wd);
      });
    });
    m.appendChild(box);
    setTimeout(function () { m.classList.add('on'); }, reduce ? 0 : 250);
  }

  function facade(root) {
    var fa = root.querySelector('[data-qs-facade]:not([data-qs-ready])'); if (!fa) return;
    fa.setAttribute('data-qs-ready', '1');
    var stage = fa.querySelector('.facade__stage'), frames = stage.querySelectorAll('.f'), dotsBox = fa.querySelector('.facade__dots'), dots = fa.querySelectorAll('.facade__dots button');
    /* Cambio automático: las personas no controlan las fotos, los puntos solo indican en qué foto estamos */
    stage.style.cursor = 'default';
    if (dotsBox) { dotsBox.style.pointerEvents = 'none'; dotsBox.setAttribute('aria-hidden', 'true'); }
    for (var q = 0; q < dots.length; q++) dots[q].tabIndex = -1;
    if (frames.length < 2) { if (dotsBox) dotsBox.style.display = 'none'; return; }
    var pos = 0, cur = 0, anim = null, timer = null;
    function setPos(p) {
      pos = p;
      for (var i = 0; i < frames.length; i++) frames[i].style.opacity = Math.max(0, Math.min(1, 1 - Math.abs(pos - i)));
      var r = Math.round(pos) % frames.length;
      for (var j = 0; j < dots.length; j++) dots[j].classList.toggle('on', j === r);
    }
    function show(i) {
      cancelAnimationFrame(anim);
      var n = frames.length, from = pos, t0 = null;
      /* Al volver de la última a la primera, fundido directo entre ambas */
      if (i === 0 && cur === n - 1) { for (var k = 0; k < n; k++) frames[k].style.opacity = (k === n - 1) ? 1 : 0; from = 0; }
      cur = i;
      if (reduce) { setPos(i); return; }
      if (i === 0 && from === 0 && frames[n - 1].style.opacity === '1') {
        (function tickW(t) {
          if (t0 === null) t0 = t;
          var k = Math.min(1, (t - t0) / 900), e = 1 - Math.pow(1 - k, 3);
          frames[n - 1].style.opacity = 1 - e; frames[0].style.opacity = e;
          for (var j = 0; j < dots.length; j++) dots[j].classList.toggle('on', j === (e > .5 ? 0 : n - 1));
          if (k < 1) anim = requestAnimationFrame(tickW); else setPos(0);
        })(performance.now());
        return;
      }
      (function tick(t) {
        if (t0 === null) t0 = t;
        var k = Math.min(1, (t - t0) / 900), e = 1 - Math.pow(1 - k, 3);
        setPos(from + (i - from) * e);
        if (k < 1) anim = requestAnimationFrame(tick);
      })(performance.now());
    }
    function start() { if (timer || reduce) return; timer = setInterval(function () { show((cur + 1) % frames.length); }, 3000); }
    function stop() { clearInterval(timer); timer = null; }
    setPos(0);
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (en) { if (en[0].isIntersecting) start(); else stop(); }, { threshold: 0.25 }).observe(fa);
    } else { start(); }
    document.addEventListener('visibilitychange', function () { if (document.hidden) stop(); });
  }

  function gallery(root) {
    var track = root.querySelector('[data-qs-track]:not([data-qs-ready])'); if (!track) return;
    track.setAttribute('data-qs-ready', '1');
    var prev = root.querySelector('[data-qs-prev]'), next = root.querySelector('[data-qs-next]');
    function step() { var f = track.querySelector('.photo'); return f ? f.getBoundingClientRect().width + (parseFloat(getComputedStyle(track).columnGap) || 12) : 300; }
    function upd() { if (!prev) return; prev.disabled = track.scrollLeft <= 2; next.disabled = track.scrollLeft >= track.scrollWidth - track.clientWidth - 2; }
    if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: reduce ? 'auto' : 'smooth' }); });
    if (next) next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: reduce ? 'auto' : 'smooth' }); });
    track.addEventListener('scroll', function () { requestAnimationFrame(upd); }, { passive: true });
    if (window.ResizeObserver) new ResizeObserver(upd).observe(track);
    upd();
  }

  function init(root) { reveal(root); mask(root); facade(root); gallery(root); }
  function boot() { init(document); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
